import api from '../services/api'
import moment from 'moment';

export default {
    namespaced: true,
    state: {
        tasksLoading: false,
        tasksLoadError: "",
        dailyHusbandryTaskTypes: [],

        observationsLoading: false,
        observationsLoadError: "",
        dailyHusbandryObservationTypes: [],

        latestEventLoading: false,
        latestEventLoadError: "",
        latestEventDetails: {},

        saving: false,
        saveError: "",

        // medical observations
        savingMedicalObservation: false,
        saveMedicalObservationError: "",
        medicalObservationTypes: [],
        loadingMedicalObservationTypes: false,
        loadErrorMedicalObservationTypes: "",

        // controlled occurrences
        savingControlledOccurrence: false,
        saveControlledOccurrenceError: "",
        controlledOccurrenceTypes: [],
        loadingControlledOccurrenceTypes: false,
        loadErrorControlledOccurrenceTypes: "",

        // dangerous occurrences
        savingDangerousOccurrence: false,
        saveDangerousOccurrenceError: "",
        DangerousOccurrenceTypes: [],
        loadingDangerousOccurrenceTypes: false,
        loadErrorDangerousOccurrenceTypes: "",

        historyLoading: false,
        historyLoadError: "",
        husbandryHistory: [],
        husbandryHistoryTotal: 0,

        // deleting daily husbandry records
        deleteError: "",
        deleting: false
    },

    getters: {
        tasksLoadInProgress(state) {
            return state.tasksLoading;
        },
        getDailyHusbandryTaskTypes(state) {
            return state.dailyHusbandryTaskTypes;
        },

        observationsLoadInProgress(state) {
            return state.observationsLoading;
        },
        getDailyHusbandryObservationTypes(state) {
            return state.dailyHusbandryObservationTypes;
        },
        getMedicalObservationTypes(state) {
            return state.medicalObservationTypes;
        }
    },

    mutations: {
        // medical observations
        savingMedicalObservation(state) {
            state.savingMedicalObservation = true;
            state.saveMedicalObservationError = "";
        },
        saveMedicalObservationComplete(state) {
            state.savingMedicalObservation = false;
        },
        saveMedicalObservationError(state, err) {
            state.saveMedicalObservationError = err;
        },
        clearMedicalObservationSaveError(state) {
            state.saveMedicalObservationError = "";
        },
        setMedicalObservationTypes(state, data) {
            state.medicalObservationTypes = data;
        },
        loadingMedicalObservationTypes(state) {
            state.loadingMedicalObservationTypes = true;
            state.loadErrorMedicalObservationTypes = "";
        },
        loadMedicalObservationTypesComplete(state) {
            state.loadingMedicalObservationTypes = false;
        },
        loadMedicalObservationTypesError(state, err) {
            state.medicalObservationTypes = [];
            state.loadErrorMedicalObservationTypes = err;
        },

        // controlled occurrences
        savingControlledOccurrence(state) {
            state.savingControlledOccurrence = true;
            state.saveControlledOccurrenceError = "";
        },
        saveControlledOccurrenceComplete(state) {
            state.savingControlledOccurrence = false;
        },
        saveControlledOccurrenceError(state, err) {
            state.saveControlledOccurrenceError = err;
        },
        clearControlledOccurrenceSaveError(state) {
            state.saveControlledOccurrenceError = "";
        },
        setControlledOccurrenceTypes(state, data) {
            state.controlledOccurrenceTypes = data;
        },
        loadingControlledOccurrenceTypes(state) {
            state.loadingControlledOccurrenceTypes = true;
            state.loadErrorControlledOccurrenceTypes = "";
        },
        loadControlledOccurrenceTypesComplete(state) {
            state.loadingControlledOccurrenceTypes = false;
        },
        loadControlledOccurrenceTypesError(state, err) {
            state.controlledOccurrenceTypes = [];
            state.loadErrorControlledOccurrenceTypes = err;
        },

        // dangerous occurrences
        savingDangerousOccurrence(state) {
            state.savingDangerousOccurrence = true;
            state.saveDangerousOccurrenceError = "";
        },
        saveDangerousOccurrenceComplete(state) {
            state.savingDangerousOccurrence = false;
        },
        saveDangerousOccurrenceError(state, err) {
            state.saveDangerousOccurrenceError = err;
        },
        clearDangerousOccurrenceSaveError(state) {
            state.saveDangerousOccurrenceError = "";
        },
        setDangerousOccurrenceTypes(state, data) {
            state.dangerousOccurrenceTypes = data;
        },
        loadingDangerousOccurrenceTypes(state) {
            state.loadingDangerousOccurrenceTypes = true;
            state.loadErrorDangerousOccurrenceTypes = "";
        },
        loadDangerousOccurrenceTypesComplete(state) {
            state.loadingDangerousOccurrenceTypes = false;
        },
        loadDangerousOccurrenceTypesError(state, err) {
            state.dangerousOccurrenceTypes = [];
            state.loadErrorDangerousOccurrenceTypes = err;
        },

        // deleting daily husbandry records
        clearDeleteError(state) {
            state.deleteError = "";
        },
        deletingDailyHusbandryRecord(state) {
            state.deleting = true;
            state.deleteError = "";
        },
        deleteDailyHusbandryRecordError(state, err) {
            state.deleteError = err;
        },
        deleteDailyHusbandryRecordComplete(state) {
            state.deleting = false;
        },

        setDailyHusbandryTaskTypes(state, data) {
            state.dailyHusbandryTaskTypes = data;
        },
        tasksLoading(state) {
            state.tasksLoading = true;
            state.tasksLoadError = "";
        },
        tasksLoadComplete(state) {
            state.tasksLoading = false;
        },
        tasksLoadError(state, err) {
            state.dailyHusbandryTaskTypes = [];
            state.tasksLoadError = err;
        },

        setDailyHusbandryObservationTypes(state, data) {
            state.dailyHusbandryObservationTypes = data;
        },
        observationsLoading(state) {
            state.observationsLoading = true;
            state.observationsLoadError = "";
        },
        observationsLoadComplete(state) {
            state.observationsLoading = false;
        },
        observationsLoadError(state, err) {
            state.dailyHusbandryObservationTypes = [];
            state.observationsLoadError = err;
        },

        setLatestEventDetails(state, data) {
            state.latestEventDetails = data;
        },
        latestEventLoading(state) {
            state.latestEventLoading = true;
            state.latestEventLoadError = "";
        },
        latestEventLoadComplete(state) {
            state.latestEventLoading = false;
        },
        latestEventLoadError(state, err) {
            state.latestEventDetails = {};
            state.latestEventLoadError = err;
        },

        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        },
        clearSaveError(state) {
            state.saveError = "";
        },

        setHusbandryHistory(state, data) {
            state.husbandryHistory = data;
        },
        setHusbandryHistoryTotal(state, data) {
            state.husbandryHistoryTotal = data;
        },
        historyLoading(state) {
            state.historyLoading = true;
            state.historyLoadError = "";
        },
        historyLoadComplete(state) {
            state.historyLoading = false;
        },
        historyLoadError(state, err) {
            state.husbandryHistory = [];
            state.historyLoadError = err;
        },
    },

    actions: {
        loadDailyHusbandryTaskTypes(context) {
            return new Promise((resolve, reject) => {
                context.commit("tasksLoading");

                api.fetchDailyHusbandryTaskTypes({
                    success: function(response) {
                        context.commit("setDailyHusbandryTaskTypes", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("tasksLoadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("tasksLoadComplete");
                    }
                });
            });
        },
        loadDailyHusbandryObservationTypes(context) {
            return new Promise((resolve, reject) => {
                context.commit("observationsLoading");

                api.fetchDailyHusbandryObservationTypes({
                    success: function(response) {
                        context.commit("setDailyHusbandryObservationTypes", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("observationsLoadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("observationsLoadComplete");
                    }
                });
            });
        },
        loadMedicalObservationTypes(context) {
            return new Promise((resolve, reject) => {
                context.commit("loadingMedicalObservationTypes");

                api.fetchMedicalObservationTypes({
                    success: function(response) {
                        context.commit("setMedicalObservationTypes", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadMedicalObservationTypesError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadMedicalObservationTypesComplete");
                    }
                });
            });
        },
        loadLatestEvent(context, params) {
            return new Promise((resolve, reject) => {
                context.commit("latestEventLoading");

                api.fetchLatestEventDetails({
                    params: {
                        SpecimenID: params.SpecimenID,
                        GetLatest: true
                    },
                    success: function(response) {
                        context.commit("setLatestEventDetails", response.data);

                        resolve();
                    },
                    error: function(e) {
                        context.commit("latestEventLoading", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("latestEventLoadComplete");
                    }
                });
            });
        },

        clearSaveError(context) {
            context.commit("clearSaveError");
        },
        clearMedicalObservationSaveError(context) {
            context.commit("clearMedicalObservationSaveError");
        },
        saveDailyHusbandry(context, options) {
            context.commit("saving");

            api.saveDailyHusbandry(
                options.dailyHusbandry, {
                    success: function(response) {
                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        saveMedicalObservation(context, options) {
            context.commit("savingMedicalObservation");

            // date and time are separate, but we should combine them into a single field
            // note that this converts it to UTC from the client's local timezone - UTC is what we store in the database
            options.medicalObservation.UTCTime = moment(options.medicalObservation.Date + " " + options.medicalObservation.Time).toISOString();

            api.saveMedicalObservation(
                options.medicalObservation, {
                    success: function(response) {
                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveMedicalObservationError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveMedicalObservationComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },


        loadHusbandryHistory(context, options) {
            return new Promise(() => {
                context.commit("historyLoading");

                api.fetchHusbandryHistory({
                    params: options.params,
                    success: function(response) {
                        context.commit("setHusbandryHistory", response.data.HusbandryHistory);
                        context.commit("setHusbandryHistoryTotal", response.data.HusbandryHistoryTotal);

                        if (options.success) {
                            options.success(response.data);
                        }
                    },
                    error: function(e) {
                        context.commit("historyLoadError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("historyLoadComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                });
            });
        },

        loadControlledOccurrenceTypes(context) {
            return new Promise((resolve, reject) => {
                context.commit("loadingControlledOccurrenceTypes");

                api.fetchControlledOccurrenceTypes({
                    success: function(response) {
                        context.commit("setControlledOccurrenceTypes", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadControlledOccurrenceTypesError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadControlledOccurrenceTypesComplete");
                    }
                });
            });
        },
        clearControlledOccurrenceSaveError(context) {
            context.commit("clearControlledOccurrenceSaveError");
        },
        saveControlledOccurrence(context, options) {
            context.commit("savingControlledOccurrence");

            // date and time are separate, but we should combine them into a single field
            // note that this converts it to UTC from the client's local timezone - UTC is what we store in the database
            options.controlledOccurrence.UTCTime = moment(options.controlledOccurrence.Date + " " + options.controlledOccurrence.Time).toISOString();

            api.saveControlledOccurrence(
                options.controlledOccurrence, {
                    success: function(response) {
                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveControlledOccurrenceError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveControlledOccurrenceComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },

        loadDangerousOccurrenceTypes(context) {
            return new Promise((resolve, reject) => {
                context.commit("loadingDangerousOccurrenceTypes");

                api.fetchDangerousOccurrenceTypes({
                    success: function(response) {
                        context.commit("setDangerousOccurrenceTypes", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadDangerousOccurrenceTypesError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadDangerousOccurrenceTypesComplete");
                    }
                });
            });
        },
        clearDangerousOccurrenceSaveError(context) {
            context.commit("clearDangerousOccurrenceSaveError");
        },
        saveDangerousOccurrence(context, options) {
            context.commit("savingDangerousOccurrence");

            // date and time are separate, but we should combine them into a single field
            // note that this converts it to UTC from the client's local timezone - UTC is what we store in the database
            options.dangerousOccurrence.UTCTime = moment(options.dangerousOccurrence.Date + " " + options.dangerousOccurrence.Time).toISOString();

            api.saveDangerousOccurrence(
                options.dangerousOccurrence, {
                    success: function(response) {
                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveDangerousOccurrenceError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveDangerousOccurrenceComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },

        clearDeleteError(context) {
            context.commit("clearDeleteError");
        },

        deleteDailyHusbandryRecord(context, options) {
            context.commit("deletingDailyHusbandryRecord");

            api.deleteDailyHusbandryRecord(
                options.record, {
                    success: function(response) {
                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("deleteDailyHusbandryRecordError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("deleteDailyHusbandryRecordComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        }
    }
}